<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
    <mat-card>
    <mat-card-header>
      <mat-card-title>
        <span>{{dataSource && dataSource.data ? (dataSource.data.length | i18nPlural: facilityPluralMapping) : '0 Facilities'}}</span>
        <span class="float-right">
          @if (admin) {
            <a [routerLink]="['/facilities/', accountId, 'add']" aria-label="Add Facility" color="primary"
            mat-raised-button="">Create New Facility</a>
          }
        </span>
      </mat-card-title>
      <mat-card-subtitle>
        <mat-form-field>
          <input (keyup)="search($event)" matInput placeholder="Search">
        </mat-form-field>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mat-elevation-z8">
      <table [dataSource]="dataSource" mat-table matSort [matSortDisableClear]="true">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
          <td *matCellDef="let element" mat-cell><a
          [routerLink]="['/facilities', element.id, 'locations']">{{element.name}}</a></td>
        </ng-container>

        <!-- Address Column -->
        <ng-container matColumnDef="address">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Address</th>
          <td *matCellDef="let element" mat-cell><a
          [routerLink]="['/facilities', element.id, 'locations']">{{element.address}}</a></td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
          <td *matCellDef="let row" mat-cell>{{row.created.toDate() | dateFormat}}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="column-less" mat-header-cell>Actions</th>
          <td *matCellDef="let row" mat-cell>
              <div class="flex items-center gap-2">
                  <button [routerLink]="['/facilities/', row.id, 'items']" matButton="elevated" color="primary">All Items</button>
                  @if (admin) {
                      <button [routerLink]="['/facilities/edit/', row.id]" color="primary"
                              matMiniFab><i class="material-icons">edit</i></button>
                  }
                  @if (admin) {
                      <button (click)="deleteFacility(row)" color="primary" matMiniFab><i
                          class="material-icons">delete</i></button>
                  }
              </div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[15, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
